<nz-layout class="layout">
      @if (this.authService.hasClaims(['MEN'])) { 
        <nz-sider nzCollapsible nzBreakpoint="lg" [nzCollapsedWidth]="50" [(nzCollapsed)]="isSiderCollapsed">
          <div class="logo"><img src="app_logo.png" alt="360 TRUX" style="width: 100%; height: auto;" /></div>
          <ul nz-menu nzTheme="dark" nzMode="inline">
            <li nz-menu-item nzMatchRouter>            
              <a routerLinkActive="activebutton" routerLink="/home"><nz-icon nzType="home" nzTheme="outline" /><span>Home</span></a>
            </li>
            @if (authService.hasClaims(['NEW'])) {
            <li nz-menu-item nzMatchRouter routerLink="/incident/new">            
              <nz-icon nzType="truck" nzTheme="outline" />
              <span>New Breakdown</span>
            </li>
            }
            @if (authService.hasClaims(['DCM'])) {
            <li nz-menu-item nzMatchRouter routerLink="/datacapture">            
              <nz-icon nzType="insert-row-left" nzTheme="outline" />
              <span>Data Capture</span>
            </li>
            }
            @if (authService.hasClaims(['INC'])) {
            <li nz-menu-item nzMatchRouter routerLink="/incidents">
              <nz-icon nzType="unordered-list" nzTheme="outline" />
              <span>All Breakdowns</span>
            </li>
            }
            @if (authService.hasClaims(['PRI'])) {
            <li nz-menu-item nzMatchRouter routerLink="/pricing">
              <nz-icon nzType="tags" nzTheme="outline" />
              <span>Pricing</span>
            </li>
            }
            @if (authService.hasClaims(['CST'])) {
            <li nz-menu-item nzMatchRouter routerLink="/custom-stock">
              <nz-icon nzType="stock" nzTheme="outline" />
              <span>Custom Stock</span>
            </li>
            }
            @if (authService.hasClaims(['SPM'])) {
            <li nz-menu-item nzMatchRouter routerLink="/service-providers">
              <nz-icon nzType="solution" nzTheme="outline" />
              <span>Service Providers</span>
            </li>
            }
            @if (authService.isClientServiceProvider) {
            <li nz-menu-item nzMatchRouter routerLink="/sp-network">
              <nz-icon nzType="apartment" nzTheme="outline" />
              <span>SP Network</span>
            </li>
            }
            @if (authService.hasClaims(['FLM'])) {
            <li nz-menu-item nzMatchRouter routerLink="/fleet">
              <nz-icon nzType="car" nzTheme="outline" />
              <span>Fleet Controllers</span>
            </li>
            }
            <li nz-menu-item nzMatchRouter routerLink="/settings">
              <nz-icon nzType="setting" nzTheme="outline" />
              <span>Settings</span>
            </li>
            <li nz-menu-item (click)="onClickLogout()">              
                <nz-icon nzType="logout" nzTheme="outline" /><span>Logout</span>              
            </li>
          </ul>
        </nz-sider>
      }
      <nz-layout class="main-content">

        <nz-header class="main-header">
            <div nz-row class="header-row">
            <div
              nz-col
              [nzXs]="24"
              [nzSm]="24"
              [nzMd]="8"
              [nzLg]="8"
              class="header-user header-user--selector"
              role="button"
              tabindex="0"
              title="Change call centre operator"
              (click)="onSelectCallcentreOperator()"
              (keydown.enter)="onSelectCallcentreOperator()"
              (keydown.space)="onSelectCallcentreOperator()">
              <nz-icon nzType="user" nzTheme="outline"></nz-icon>
              <div class="header-user__details">
                <div>{{ authService.user?.firstName }} {{ authService.user?.lastName }}</div>
                @if (authService.callcentreOperator && authService.callcentreOperator.userId !== authService.user?.userId) {
                  <div class="header-user__operator">
                    Loading breakdowns as: {{ authService.callcentreOperator.firstName }} {{ authService.callcentreOperator.lastName }}
                  </div>
                }
              </div>
              <nz-icon class="header-user__change-icon" nzType="swap" nzTheme="outline"></nz-icon>
            </div>
                    @if (!this.authService.isBreakdownTechnician) {
            <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="8" class="header-title">
              TRUCK BREAKDOWN
            </div>
          }
            <div nz-col [nzXs]="24" [nzSm]="24" [nzMd]="8" [nzLg]="8" class="header-client">
              <div nz-row nzJustify="end" nzAlign="middle" nzGutter="16">
                <app-stats style="margin-right: 16px;" (whatsappOpened)="onWhatsappOpenedFromStats()"></app-stats>
                <nz-icon nzType="bank" nzTheme="outline"></nz-icon> {{authService.user?.clientName}}
              </div>
            </div>
          </div>
        </nz-header>
          

        <nz-content >
          <router-outlet></router-outlet>
        </nz-content>
        @if (!this.authService.isBreakdownTechnician) {
          <nz-footer>360Trux&copy; by StockFinder v{{appVersion}}</nz-footer>
        }
      </nz-layout>
      
      <!-- WhatsApp Messages Right Sidebar -->
      @if (sharedDataService.isWhatsappDrawerVisible) {
        <nz-sider 
          nzTheme="light" 
          [nzWidth]="450" 
          [nzCollapsedWidth]="0"
          [nzCollapsed]="!sharedDataService.isWhatsappDrawerVisible"
          [nzCollapsible]="false"
          class="messages-sidebar"
          style="background: #fff; border-left: 1px solid #f0f0f0;">
          <div style="padding: 16px; border-bottom: 1px solid #f0f0f0; display: flex; justify-content: space-between; align-items: center;">
            <h3 style="margin: 0;">WhatsApp Messages</h3>
            <button nz-button nzType="text" (click)="onCloseWhatsAppDrawer()">
              <nz-icon nzType="close" nzTheme="outline"></nz-icon>
            </button>
          </div>
          <div style="padding: 16px; overflow-y: auto; height: calc(100vh - 120px);">
            <app-whatsapp></app-whatsapp>
          </div>
        </nz-sider>
      }
    </nz-layout>


    <!-- <ng-template #siderTriggerZero>
      <nz-icon nzType="menu-unfold" />
    </ng-template>

    <nz-drawer
      [nzClosable]="true"
      [nzVisible]="sharedDataService.isWhatsappDrawerVisible"
      nzPlacement="right"
      nzTitle="WhatsApp Messages"
      [nzWidth]="'500px'"
      [nzMask]="false"
      (nzOnClose)="onCloseWhatsAppDrawer()"
    >
           <ng-container *nzDrawerContent>

             <app-whatsapp></app-whatsapp>
    
        @for (msg of sharedDataService.messages; track msg.type) {
            <nz-collapse>
              @if (msg.type === 6) {
                <nz-collapse-panel [nzHeader]="'NEW INCIDENT'" [nzActive]="true">
                  <p>{{ sharedDataService.messageAsObject(msg).message }}</p>
                  @if (msg.type === socketMessageType.WhatsappIncident) {
                    <button nz-button [nzType]="'primary'" (click)="onClickCreateNewIncident(msg)">Action Breakdown Incident</button>
                  }
                </nz-collapse-panel>
              } 
              @else if (msg.type === 8) {
                <nz-collapse-panel [nzHeader]="'DOCUMENT'" [nzActive]="true">
                  @if (sharedDataService.messageAsObject(msg).docUrl) {
                    <a href="{{ sharedDataService.messageAsObject(msg).docUrl }}" target="_blank">
                      <img src="{{ sharedDataService.messageAsObject(msg).docUrl }}" alt="Document Image" style="max-width: 100%; height: auto;" />

                    </a>
                  }
                  <p>{{ sharedDataService.messageAsObject(msg).message }}</p>
                  <button nz-button [nzType]="'primary'" (click)="onClickAddToIncident(msg)">Add To Incident</button>
                </nz-collapse-panel>
              }
            </nz-collapse>
        }
        <nz-divider></nz-divider> 
    
       </ng-container>
 
    </nz-drawer> -->
